
  import { Component, Vue } from 'vue-property-decorator';
  import {IAppState} from "@/interfaces/app-state.interface";
  import {IAppConfirm} from "@/modules/Popup/interfaces/app-confirm-state.interface";

  @Component({})
  export default class AppConfirmPopup extends Vue {

    get storeState(): IAppState { return this.$store.state; }
    get confirmState(): IAppConfirm.State { return this.storeState.confirm; }
    get isVisible() { return this.storeState.confirm.isVisible; }

    mounted() {
      window.addEventListener('keydown', this.onKeyPress, {capture: true, passive: false});
    }

    onKeyPress(event) {
      if (event.keyCode === 13) { // on "Enter" pressed
        this.onConfirm();
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        event.returnValue = false;
        event.cancelBubble = true;
        return false;
      }
    }

    onCancel() {
      this.$store.dispatch('confirm/cancel');
    }

    onConfirm () {
      this.$store.dispatch('confirm/confirm');
    }

    destroyed() {
      window.removeEventListener('keydown', this.onKeyPress, true);
    }
  }
